module.exports = __webpack_public_path__ + "img/is.db225c1a.jpg";